import type { TourStep } from '../types';

export const mileageReportSteps: TourStep[] = [
  {
    target: '[data-tour="mileage-stats"]',
    title: 'Mileage Summary',
    content:
      'Your totals at a glance — miles driven, IRS deduction, trip count, average miles per assignment, drive time, fuel cost, and cost per appraisal.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="mileage-table"]',
    title: 'Trip Ledger',
    content:
      'Every trip listed with date, status, file numbers, miles, IRS rate, deduction, duration, and fuel cost. Use the tabs to switch between tax years or view all years at once, and click any row for the full route details.',
    placement: 'top',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="mileage-export"]',
    title: 'Export for Tax Filing',
    content:
      'Download a CSV for your accountant or tax records. The export covers whichever view is selected — a single tax year, a custom range, or all years — with every trip and all calculated fields.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'Got it',
  },
  {
    target: '[data-tour="mileage-regenerate"]',
    title: 'Advanced: Force Recalculate',
    content:
      'Most of the time Sync is all you need — it reuses every cached trip and only computes new or changed days. For the rare case where the numbers look wrong, open this menu to discard the cache and re-route the current view from scratch. There\'s a brief cooldown between runs.',
    placement: 'bottom',
    spotlightClicks: true,
  },
];
